var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6562 1.95312C20.0781 -0.203125 16.2812 0.125 13.8906 2.60938L13 3.54688L12.0625 2.60938C10.1406 0.640625 6.29688 -0.578125 3.29688 1.95312C0.34375 4.48438 0.203125 8.98438 2.82812 11.7031L11.9219 21.0781C12.2031 21.3594 12.5781 21.5 12.9531 21.5C13.375 21.5 13.75 21.3594 14.0312 21.0781L23.125 11.7031C25.75 8.98438 25.6094 4.48438 22.6562 1.95312ZM22.0469 10.6719L13 20.0469L3.90625 10.6719C2.125 8.79688 1.75 5.28125 4.28125 3.125C6.85938 0.921875 9.85938 2.51562 10.9844 3.64062L13 5.70312L14.9688 3.64062C16.0469 2.51562 19.0938 0.921875 21.6719 3.125C24.2031 5.28125 23.8281 8.79688 22.0469 10.6719Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyHeart);
export default __webpack_public_path__ + "static/media/empty-heart.07a89f4a.svg";
export { ForwardRef as ReactComponent };